import unit from "../unit";
var getBoxShadowBorder = function getBoxShadowBorder(width, color) {
  return "inset 0 0 0 ".concat(unit(width), " ").concat(color);
};
export default getBoxShadowBorder;